module.exports = __webpack_public_path__ + "static/media/notice.7202476c.webp";